import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from './spinner/spinner.component';
import {FirstPageLayoutComponent} from './first-page-layout/first-page-layout.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { IsOrgPipe } from './is-org.pipe';
import { LoadingDotsComponent } from './loading-dots/loading-dots.component';


@NgModule({
    declarations: [
        SpinnerComponent,
        FirstPageLayoutComponent,
        IsOrgPipe,
        LoadingDotsComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        LayoutModule,
    ],
    exports: [
        SpinnerComponent,
        LoadingDotsComponent,
        FirstPageLayoutComponent,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        IsOrgPipe,
    ]
})
export class SharedModule {
}
